import type { UsageRowDTO } from '@copilot/shared';

export type UsageTotals = Omit<UsageRowDTO, 'userId' | 'userName' | 'email' | 'month'>;

/** Totals row for the usage table. */
export function sumUsage(rows: UsageRowDTO[]): UsageTotals {
  const t: UsageTotals = { requests: 0, inputTokens: 0, outputTokens: 0, cacheReadTokens: 0, cacheWriteTokens: 0, costUsd: 0, limitUsd: 0 };
  for (const r of rows) {
    t.requests += r.requests;
    t.inputTokens += r.inputTokens;
    t.outputTokens += r.outputTokens;
    t.cacheReadTokens += r.cacheReadTokens;
    t.cacheWriteTokens += r.cacheWriteTokens;
    t.costUsd += r.costUsd;
    t.limitUsd += r.limitUsd;
  }
  return t;
}
